import { render, staticRenderFns } from "./SegmentedTrendsAppViewTable.vue?vue&type=template&id=1983eab7&scoped=true"
import script from "./SegmentedTrendsAppViewTable.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsAppViewTable.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsAppViewTable.vue?vue&type=style&index=0&id=1983eab7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983eab7",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-app-view-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsAppViewTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports